var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c(
        "w-row",
        { attrs: { stretch: "" } },
        [
          _c("w-col", [
            _c("h2", [_vm._v(_vm._s(_vm.$ct("personalize-with-logo")))]),
          ]),
          _c(
            "transition",
            { attrs: { name: "fast-fade", mode: "out-in" } },
            [
              _vm.uploadComplete && _vm.fileUrl
                ? _c(
                    "w-col",
                    { staticClass: "logo-container", attrs: { xs: "12" } },
                    [
                      _c("div", { staticClass: "logo-wrapper" }, [
                        _c("div", {
                          staticClass: "logo",
                          staticStyle: {
                            "background-repeat": "no-repeat",
                            "background-size": "contain",
                            "background-position": "center",
                          },
                          style: {
                            "background-image": "url(" + _vm.fileUrl + ")",
                          },
                        }),
                      ]),
                    ]
                  )
                : _c(
                    "w-col",
                    { staticClass: "avatar", attrs: { xs: "12" } },
                    [_c("w-fa", { attrs: { icon: "user-circle" } })],
                    1
                  ),
            ],
            1
          ),
          _c(
            "w-col",
            { attrs: { xs: "12" } },
            [
              _c("app-file-upload", {
                attrs: {
                  sending: _vm.sending,
                  disabled: _vm.controlsDisabled,
                  label: _vm.$ct("upload-label"),
                  "allowed-extensions": _vm.allowedExtensions,
                },
                on: {
                  input: function ($event) {
                    return _vm.onInput($event)
                  },
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c("w-row", { staticClass: "mt" }),
      _c(
        "w-row",
        [
          _c(
            "w-button",
            {
              staticClass: "cancel",
              attrs: { disabled: _vm.controlsDisabled },
              on: {
                click: function ($event) {
                  return _vm.prev()
                },
              },
            },
            [_vm._v(" " + _vm._s(_vm.$t("common.back")) + " ")]
          ),
          _c("w-spacer"),
          _c(
            "w-button",
            {
              staticClass: "cancel",
              style: { marginRight: "5px" },
              attrs: { disabled: _vm.controlsDisabled },
              on: {
                click: function ($event) {
                  return _vm.skip()
                },
              },
            },
            [_vm._v(" " + _vm._s(_vm.$t("common.later")) + " ")]
          ),
          _c(
            "w-button",
            {
              staticClass: "ml",
              attrs: { disabled: _vm.controlsDisabled },
              on: {
                click: function ($event) {
                  return _vm.next()
                },
              },
            },
            [_vm._v(" " + _vm._s(_vm.$t("common.complete")) + " ")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }